module.exports = ".dashboard {\n  padding: 20px 0 0 0;\n}\n.dashboardLink {\n  padding: 15px 30px;\n  background: #e6e6e6;\n  border-radius: 25px;\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  overflow: hidden;\n}\n.dashboard-title {\n  float: left;\n  margin: 0;\n}\n.dashboard-icon {\n  float: right;\n}\n.dashboard-icon:before {\n  font-size: 2rem;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/viewsmodule/dashboard/dashboard.home.css
// module id = 501
// module chunks = 0